import template from './reset-password-modal.pug'

export default Vue.extend({
  template: template(),
  props: {
    userId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      password: '',
      confirmPassword: ''
    }
  },
  methods: {
    submit() { 

      this.$emit('submit', {
        password: this.password,
        confirmPassword: this.confirmPassword
      })
    }
  }
})
